import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { allBloquesPedagogicosAction } from '../bloques_pedagogicos/BloquesPedagogicosAction';

const PanelControlEstudiosHook = () => {
  const dispatch = useDispatch();

  const { activo } = useSelector((state) => state.entidades);
  const { all } = useSelector((state) => state.bloquesPedagogicos);

  useEffect(() => {
    if (all.length === 0) {
      allBloquesPedagogicosAction(dispatch, {
        idEntidad: activo.id,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    bloquesPedagogicos: all,
  };
};

export default PanelControlEstudiosHook;
